import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="relative pt-16 pb-10 px-6 md:pt-20 md:pb-14 max-w-4xl mx-auto text-center" data-id="element-87">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-[#4A5D3A] opacity-5 blur-[100px] rounded-full pointer-events-none" data-id="element-88"></div>

      <FadeIn data-id="element-89">
        <p className="text-sm md:text-base italic text-[#9B4F2B] mb-6 font-medium tracking-wide" data-id="element-90">
          Para mujeres que no logran apagar el ruido mental al final del día.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-91">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2D2A26] leading-tight mb-8" data-id="element-92">
          No es solo la planta. Es el método botánico correcto para calmar tu
          sistema nervioso.
        </h1>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-93">
        <div className="max-w-3xl mx-auto" data-id="element-94">
          <p className="text-lg md:text-xl text-[#2D2A26] mb-4 leading-relaxed" data-id="element-95">
            Descubre el protocolo de 15 minutos que te enseña qué plantas usar,
            en qué dosis y cómo prepararlas correctamente para ayudar a tu mente
            a soltar, bajar revoluciones y descansar mejor.
          </p>
          <h2 className="text-2xl md:text-3xl font-serif italic text-[#4A5D3A] font-semibold mb-8" data-id="element-96">
            "Ya estamos a salvo. Ya puedes soltar."
          </h2>

          <img src="https://cdn.magicpatterns.com/uploads/o8sNLG3chtmHx3UkA9gpkv/MOCKUP.png" alt="Rescate Herbáceo S.O.S. — Guía digital completa" className="w-full max-w-2xl mx-auto rounded-2xl shadow-xl mb-8" data-id="element-97" />

          <a href="https://pay.hotmart.com/Y104754180A" className="inline-block w-full max-w-lg mx-auto text-center bg-[#4A5D3A] text-[#FAF6F0] font-bold py-5 px-8 rounded-xl shadow-lg hover:bg-[#3a4a2e] transition-colors text-lg md:text-xl animate-pulse-subtle" data-id="element-98">
            QUIERO EL MÉTODO DE RESCATE BOTÁNICO → $6.39 USD
          </a>
          <p className="text-sm text-[#2D2A26]/60 font-medium mt-3" data-id="element-99">
            🔒 Pago Seguro ⚡ Acceso en 2 min
          </p>
        </div>
      </FadeIn>
    </section>;
}